import { defineComponent as p, computed as o } from "vue";
import { useDetectDevice as s } from "./td-longtail-vue-components93.js";
import u from "./td-longtail-vue-components3.js";
import f from "./td-longtail-vue-components13.js";
import c from "./td-longtail-vue-components12.js";
const b = /* @__PURE__ */ p({
  __name: "get-app",
  props: {
    linkApple: { default: void 0 },
    linkGoogle: { default: void 0 },
    tealiumSuffix: { default: "" },
    ariaLabel: { default: void 0 },
    showOnlyDeviceLabel: { type: Boolean }
  },
  setup(r) {
    const e = r, t = s(), l = o(() => e.linkGoogle ? e.showOnlyDeviceLabel ? ["Desktop", "Android"].includes(t.value) : !0 : !1), a = o(() => e.linkApple ? e.showOnlyDeviceLabel ? ["Desktop", "iOS"].includes(t.value) : !0 : !1), n = o(() => e.ariaLabel ? `${e.ariaLabel} im Play Store öffnen` : "Zum Google Play Store"), i = o(() => e.ariaLabel ? `${e.ariaLabel} im App Store öffnen` : "Zum App Store");
    return { __sfc: !0, props: e, device: t, showPlaystore: l, showAppstore: a, titlePlaystore: n, titleAppstore: i, LinkButton: u, GooglePlayIcon: f, AppStoreIcon: c };
  }
});
export {
  b as default
};
